<template>
    <div>
        <div ref="containt">
            <v-row justify="center">
                <v-dialog
                    v-model="dialog"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-toolbar dark color="primary" class="d-print-none">
                            <v-btn icon dark @click="close()">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn dark text>Click Add Case</v-btn>
                            </v-toolbar-items>
                        </v-toolbar>

                        <v-list class="d-print-none" three-line subheader>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <b>Part Same Item</b>
                                    </v-list-item-title>
                                    <!-- <v-list-item-subtitle></v-list-item-subtitle> -->
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <template>
                            <v-card flat>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-simple-table>
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    class="text-center"
                                                                >
                                                                    Project
                                                                </th>
                                                                <th
                                                                    class="text-center"
                                                                >
                                                                    Owner
                                                                </th>
                                                                <th
                                                                    class="text-center"
                                                                >
                                                                    Engineer
                                                                </th>
                                                                <th
                                                                    class="text-center"
                                                                >
                                                                    Case Id
                                                                </th>
                                                                <th
                                                                    class="text-center"
                                                                >
                                                                    CSO
                                                                </th>
                                                                <th
                                                                    class="text-center"
                                                                >
                                                                    Site
                                                                </th>
                                                                <th
                                                                    class="text-center"
                                                                >
                                                                    Date
                                                                </th>
                                                                <th>Status</th>
                                                                <th>
                                                                    <v-btn
                                                                        :color="
                                                                            colorx
                                                                        "
                                                                        rounded
                                                                        small
                                                                        @click="
                                                                            all()
                                                                        "
                                                                        class="ml-4"
                                                                    >
                                                                        All</v-btn
                                                                    >
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td>
                                                                    <v-checkbox
                                                                        v-model="
                                                                            checkbox
                                                                        "
                                                                        label=""
                                                                        color="green"
                                                                        class="mar-1"
                                                                    ></v-checkbox>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-card>
                </v-dialog>
            </v-row>
        </div>
    </div>
</template>

<script>
import axios from "axios"
export default {
    props: ["dialog"],
    methods: {
        all() {
            if (this.chk === true) {
                this.chk = false
                this.colorx = "primary"
            } else {
                this.chk = true
                this.colorx = "success"
            }
        },
        close() {
            this.checkbox = []
            this.chk = false
            this.$emit("add_case")
        }
    },
    data() {
        return {
            checkbox: [],
            colorx: "primary",
            chk: false
        }
    }
}
</script>
